import { render, staticRenderFns } from "./self_diagnosis_mng.vue?vue&type=template&id=2ddc0830&scoped=true"
import script from "./self_diagnosis_mng.vue?vue&type=script&lang=js"
export * from "./self_diagnosis_mng.vue?vue&type=script&lang=js"
import style0 from "./self_diagnosis_mng.vue?vue&type=style&index=0&id=2ddc0830&lang=css"
import style1 from "./self_diagnosis_mng.vue?vue&type=style&index=1&id=2ddc0830&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc0830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddc0830')) {
      api.createRecord('2ddc0830', component.options)
    } else {
      api.reload('2ddc0830', component.options)
    }
    module.hot.accept("./self_diagnosis_mng.vue?vue&type=template&id=2ddc0830&scoped=true", function () {
      api.rerender('2ddc0830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/self_diagnosis_mng.vue"
export default component.exports